import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions } from '../store/SettingSlice';
import $ from 'jquery';
import * as JSTool from '../store/JSTool';

export default function MobileMenu(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();
    const menuAry = ['Home', 'Class', 'The Continent of Magna', 'Features'];

    return (
        <Stack sx={{
            width: window.innerWidth,
            height: window.innerHeight,
            bgcolor: 'transparent',
        }}>

            <Box component={'img'}
                onClick={() => dispatch(settingActions.setOpenMenu(false))}
                src={JSTool.getImgPath('close_black.png')}
                sx={{
                    width: '38px',
                    filter: 'invert(1)',
                    alignSelf: 'flex-end',
                    mt: 0.7,
                    mr: 1.6,
                    mb:5,
                }} />

            {menuAry.map((item, index) => {
                return <Item key={index} title={item} index={index} />
            })}

            {/* 底部icon */}
            <Stack sx={{
                width: 1,
                height: '50px',
                position: 'absolute',
                bottom: '150px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
            }}>

                <Box component={'img'} src={JSTool.getImgPath('share_tt.png')}
                    onClick={(e) => JSTool.twitterTap()}
                    sx={{
                        height: '40px',
                    }} />

                <Box component={'img'} src={JSTool.getImgPath('share_yg.png')}
                    onClick={(e) => JSTool.youTubeTap()}
                    sx={{
                        height: '40px',
                        mx:5,
                    }} />

                <Box component={'img'} src={JSTool.getImgPath('share_dis.png')}
                    onClick={(e) => JSTool.discordTap()}
                    sx={{
                        height: '40px',
                    }} />

            </Stack>

        </Stack>
    );
}

function Item(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    function itemTap(index) {
        dispatch(settingActions.setNavIndex(index));
        var instance = $('#home_page_sp')[0].swiper;
        instance.slideTo(index);
    }

    return (
        <Stack onClick={() => itemTap(props.index)}>
            <Typography sx={{
                color: 'white',
                fontFamily: window.font0,
                fontSize: 17,
                height: '70px',
                lineHeight: '70px',
                pr: 3,
                pl: 3,
                fontWeight: 'bold',
            }}>
                {props.title}
            </Typography>
            <Box sx={{
                width: 1,
                height: '1px',
                bgcolor: '#C9CDD140',
            }} />
        </Stack>
    );
}